import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlStatusMessage, StatusMessage} from '../../graphql/common.datatypes';

export interface ContactUsVars {
    data: {
        group_id?: number
        email: string
        name: string
        message: string
        adminMessage?: string
    };
}

interface ContactUsData {
    contactUs: StatusMessage
}

export const CONTACT_US_MUTATION = gql`
    mutation contactUs($data: ContactUsInput!) {
        contactUs(data: $data) {
            ${gqlStatusMessage}
        }
    }
`;

export const contactUs = () => useMutation<ContactUsData, ContactUsVars>(
    CONTACT_US_MUTATION,
);

export default contactUs;